export const no = {
  nav: {
    start: "Start",
    losningar: "Løsninger",
    produkter: "Tjenester",
    kundcase: "Kundecase",
    kunskap: "Kunnskap",
    information: "Informasjon",
    nyheter: "Nyheter",
    villkor: "Vilkår",
    developer: "Developer",
    omGeposit: "Om Geposit",
    kontakt: "Kontakt",
    bokademo: "Book demo",
    loggain: "Logg inn",
    bestall: "Bestill",
  },
  hero: {
    title: "Geografisk kontroll over virksomheten din",
    subtitle:
      "Valider adresser, håndter geografiske områder og kvalitetssikre adresseregistrene deres i Sverige, Norge, Danmark og Finland – alt i én plattform. For smartere beslutninger og færre feil i hvert ledd.",
    cta: "Book demo",
    ctaSecondary: "Se våre løsninger",
  },
  segments: {
    title: "Hvem vi hjelper",
    subtitle:
      "Geposit støtter virksomheter i Sverige, Norge, Danmark og Finland med å effektivisere geografisk planlegging og leveranselogistikk.",
    transport: {
      title: "Transport & Logistikk",
      description:
        "Definer leveranseområder med postnummerpresisjon, sikre korrekte adressedata og reduser returer. Full kontroll over transportgeografien deres.",
    },
    service: {
      title: "Service & Installasjon",
      description:
        "Planlegg serviceområder, fordel ressurser geografisk og gi kundene deres eksakte besøkstider. Unngå overlappende soner.",
    },
    ecommerce: {
      title: "E-handel & Omni",
      description:
        "Definer leveransesoner, valider kundeadresser i sanntid og optimaliser siste-mil-logistikken. Færre feil, fornøyde kunder.",
    },
  },
  problems: {
    title: "Kjenner du igjen dette?",
    subtitle: "Mange selskaper sliter med de samme geografiske utfordringene hver dag.",
    items: {
      areas: {
        title: "Utydelige områder",
        description:
          "Geografiske ansvarsområder baseres på magefølelse i stedet for data. Ingen vet egentlig hvor grensene går.",
      },
      addresses: {
        title: "Feil adressedata",
        description:
          "Pakker kommer tilbake, serviceteknikere finner ikke rett og kundene blir frustrerte over forsinkelser.",
      },
      manual: {
        title: "Manuell planlegging",
        description:
          "Excel-ark, kart på veggen og timer med manuelt arbeid for å fordele og oppdatere geografiske områder.",
      },
      overview: {
        title: "Mangel på oversikt",
        description:
          "Ingen vet egentlig hvordan de geografiske områdene ser ut eller om de er optimalt fordelt og dekker alle behov.",
      },
    },
  },
  solutions: {
    title: "Slik løser Geposit det",
    subtitle:
      "Tre pilarer som gir deg full kontroll over geografien og adressekvaliteten i hele Norden.",
    pillars: {
      areas: {
        title: "Egne områder med postnummerpresisjon",
        description:
          "Opprett, visualiser og håndter deres unike geografiske områder med postnummerflater som byggesteiner. Oppdater i sanntid når behovene endrer seg.",
      },
      data: {
        title: "Korrekte adresse- og postnummerdata",
        description:
          "Alltid oppdaterte, validerte data som sikrer at hver adresse er korrekt. Reduser returer og feilkostnader drastisk.",
      },
      control: {
        title: "Visuell oversikt & kontroll",
        description:
          "Se hele geografien deres på kartet. Analyser, optimaliser og ta beslutninger basert på data – ikke magefølelse.",
      },
    },
  },
  products: {
    title: "Våre tjenester",
    subtitle:
      "Tre kraftige verktøy som gir deg kontroll over geografi og adressedata – med full dekning i hele Norden.",
    atlas: {
      title: "Atlas",
      description:
        "Opprett og håndter egne geografiske områder for Sverige, Norge, Danmark og Finland. Visualiser, analyser og optimaliser deres geografiske strukturer på et interaktivt kart.",
      cta: "Les mer om Atlas",
    },
    valid: {
      title: "Valid",
      description:
        "Valider og berik adresser i sanntid for alle nordiske land. Sikre at hver adresse er korrekt før den når systemet deres – via API eller søketjeneste i nettgrensesnittet.",
      cta: "Les mer om Valid",
    },
    adresstwatt: {
      title: "Adressevask",
      description:
        "Vask og kvalitetssikre deres eksisterende adresseregistre i hele Norden. Finn og korriger feil i bulk for å forbedre datakvaliteten.",
      cta: "Les mer om Adressevask",
    },
  },
  productPages: {
    backToProducts: "Alle tjenester",
    features: "Funksjoner",
    benefits: "Fordeler",
    howItWorks: "Slik fungerer det",
    ctaTitle: "Klar til å komme i gang?",
    ctaSubtitle: "Book en demo og se hvordan det fungerer for nettopp deres virksomhet.",
    ctaButton: "Book demo",
    ctaSecondary: "Kontakt oss",
    atlas: {
      hero: {
        title: "Atlas",
        tagline: "Geografisk områdehåndtering",
        subtitle:
          "Opprett, visualiser og håndter deres egne geografiske områder på et interaktivt kart. Definer salgsdistrikt, leveransesoner og serviceområder med postnummerpresisjon – i Sverige, Norge, Danmark og Finland.",
      },
      overview:
        "Atlas er Geposits karttjeneste for å opprette og håndtere egne geografiske områder i hele Norden. Bygg opp områdene med postnummerflater som byggesteiner, tegn frihånd eller importer eksisterende strukturer. Visualiser data som heat maps, mål avstander og del kart med hele organisasjonen – via iFrame eller API. Atlas støtter Sverige, Norge, Danmark og Finland.",
      featureGroups: {
        createAndVisualize: "Opprett & visualiser med postnummer",
        calculateAndAnalyze: "Mål & analyser",
        integrateAndShare: "Integrer & del",
      },
      features: {
        title: "Alt du trenger for geografisk planlegging",
        subtitle:
          "Atlas gir dere verktøyene til å ta kontroll over deres geografiske strukturer – enkelt, visuelt og datadrevet.",
        items: {
          points: {
            title: "Punkter på kart",
            description:
              "Plasser punkter med adresse eller koordinat. Visualiser kundedata, lagre eller servicepunkter – enkeltvis eller som heat map.",
          },
          areas: {
            title: "Egne områder med postnummer",
            description:
              "Bygg opp områder med postnummerflater som byggesteiner – hvert postnummer klikker på plass som en puslebrikke. Tegn frihånd, importer shapefiler eller kombiner metoder for full fleksibilitet.",
          },
          heatmaps: {
            title: "Heat maps",
            description:
              "Visualiser datamønstre geografisk med heat maps. Se konsentrasjoner av kunder, leveranser eller servicebehov direkte på kartet.",
          },
          routes: {
            title: "Avstandsberegning",
            description:
              "Beregn avstander og reisetid mellom punkter. Velg kjøretøytype for realistiske estimater – en støtte ved planlegging av serviceområder og opptakssoner.",
          },
          measure: {
            title: "Måleverktøy",
            description:
              "Bruk rekkeviddssirkler for å måle avstand fra et punkt. Perfekt for å definere opptaksområder eller serviceradius.",
          },
          attributes: {
            title: "Attributter & metadata",
            description:
              "Koble egen data til områder og punkter. Legg til prissoner, ansvarlige selgere, kapasitet eller andre forretningsregler.",
          },
          iframe: {
            title: "iFrame-deling",
            description:
              "Bygg inn kartene deres direkte på en nettside eller i et internt system. Gi kolleger og partnere tilgang uten innlogging.",
          },
          api: {
            title: "API-integrasjon",
            description:
              "Hent og send data programmatisk via REST API. Integrer Atlas med deres CRM, ERP, transportsystem eller BI-plattform.",
          },
        },
      },
      useCases: {
        title: "Bruksområder",
        items: {
          salesDistricts: {
            title: "Salgsdistrikt",
            description:
              "Definer og visualiser selgernes ansvarsområder. Se dekning, identifiser hull og balanser arbeidsbelastningen.",
          },
          deliveryZones: {
            title: "Leveransesoner",
            description:
              "Opprett tydelige leveranseområder per terminal, sjåfør eller region. Alle ser det samme bildet.",
          },
          priceZones: {
            title: "Prissoner",
            description:
              "Definer geografiske soner med ulik prissetting. Koble til forretningssystemet for automatisk prisberegning.",
          },
          biConnection: {
            title: "BI & analyse",
            description:
              "Eksporter geodata til BI-verktøyet eller koble direkte via API. Geografisk dimensjon i rapportene.",
          },
          distanceCalc: {
            title: "Avstandsberegning",
            description:
              "Beregn avstander og reisetider mellom punkter med ulike kjøretøytyper. En støtte ved planlegging og timeplanlegging.",
          },
          crmConnection: {
            title: "CRM-kobling",
            description:
              "Synkroniser geografiske områder med CRM-systemet. Automatisk tildeling av kunder til rett selger.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Atlas?",
        items: {
          time: {
            title: "Spar tid",
            description:
              "Slutt med manuelle Excel-ark og papirkart. Gjør på minutter det som tidligere tok timer.",
          },
          decisions: {
            title: "Bedre beslutninger",
            description:
              "Baser geografiske beslutninger på data i stedet for magefølelse. Se mønstre og optimaliseringsmuligheter direkte.",
          },
          overview: {
            title: "Full oversikt",
            description:
              "Alle i organisasjonen ser det samme bildet. Ingen flere uklarheter om hvor grensene går.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Importer dataene deres",
            description:
              "Last opp eksisterende områder, adresser eller koordinater. Atlas støtter shapefiler, CSV og API-import.",
          },
          second: {
            title: "Opprett og tilpass",
            description:
              "Bygg områder med postnummerflater som byggesteiner, tegn frihånd, visualiser med heat maps og mål avstander.",
          },
          third: {
            title: "Del og integrer",
            description:
              "Publiser kart via iFrame, eksporter data eller koble til systemene via API.",
          },
        },
      },
      pricing: {
        features: {
          binding12: "12 måneders bindingstid",
          adminMapCountry: "1 admin, 1 kart, 1 land",
          importData: "Importer egen data på kart",
          manageAreas: "Opprett, vis og håndter områder",
          apiIntegration: "Integrer med systemene via API",
          export2000: "Eksporter 2 000 postnummer/mnd",
          exportUnlimited: "Eksporter ubegrenset med postnummer",
          routingIncluded: "Routing Small inkludert",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "1 795 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "2 995 SEK",
          },
          medium3: {
            name: "MEDIUM 3-MND",
            price: "3 595 SEK",
          },
        },
        addons: {
          extraCountry: { name: "Ekstra land", price: "1 000 SEK/mnd" },
          extraMap: { name: "Ekstra kart", price: "495 SEK/mnd" },
          extraAdmin: { name: "Ekstra admin-bruker", price: "295 SEK/mnd" },
          extraViewer: { name: "Ekstra titt-bruker", price: "95 SEK/mnd" },
          exportPostal: { name: "Eksport postnummer", small: "0,80 SEK/stk", mediumPlus: "Inkludert" },
          exportCoords: { name: "Eksport koordinater", small: "1,00 SEK/stk", mediumPlus: "0,90 SEK/stk" },
        },
      },
    },
    valid: {
      hero: {
        title: "Valid",
        tagline: "Adressevalidering & berikning",
        subtitle:
          "Valider, korriger og berik adresser i sanntid for Sverige, Norge, Danmark og Finland. Via API, autocomplete i skjemaer eller søketjeneste i nettgrensesnitt – Valid sikrer korrekte adressedata i hvert steg.",
      },
      overview:
        "Valid er Geposits tjeneste for adressevalidering, autocomplete og berikning med komplett nordisk dekning. Kontroller om en adresse finnes i Sverige, Norge, Danmark eller Finland, gi brukeren smarte forslag mens de skriver, og berik hver adresse med over 10 geografiske attributter. Tilgjengelig via REST API eller som søketjeneste i nettgrensesnittet.",
      featureGroups: {
        api: "API-tjenester",
        web: "Nettgrensesnitt",
      },
      features: {
        title: "Korrekte adressedata – hver gang",
        subtitle:
          "Valid fanger feil før de blir et problem. Integrer i systemene eller bruk søketjenesten direkte i nettleseren.",
        items: {
          validation: {
            title: "Adressevalidering",
            description:
              "Kontroller om en adresse finnes og er korrekt. Få umiddelbar tilbakemelding med statusindikering og forslag til korrigering.",
          },
          autocomplete: {
            title: "Autocomplete",
            description:
              "Gi brukeren smarte adresseforslag i sanntid mens de skriver. Raskere utfylling, færre feil, bedre brukeropplevelse.",
          },
          enrichment: {
            title: "Berikning",
            description:
              "Kompletér hver adresse med over 10 attributter: fylke, kommune, bydel, sokn, koordinater, eiendomsbetegnelse, DeSO/RegSO med mer.",
          },
          search: {
            title: "Søketjeneste i nettgrensesnitt",
            description:
              "Søk og verifiser adresser direkte i Geposits nettgrensesnitt – uten å måtte integrere via API. Perfekt for manuell kontroll.",
          },
          coverage: {
            title: "Nordisk dekning",
            description:
              "Komplett adressedatabase for Sverige, Norge, Danmark og Finland. Oppdateres hver uke med data fra offisielle grunnkilder.",
          },
        },
      },
      enrichmentData: {
        title: "Berikningsattributter",
        subtitle:
          "Hver validert adresse kan berikes med følgende geografiske og administrative attributter.",
        items: {
          county: {
            name: "Fylke",
            description: "Administrativt fylke som adressen tilhører",
          },
          municipality: {
            name: "Kommune",
            description: "Kommune som adressen er registrert i",
          },
          district: {
            name: "Bydel",
            description: "Geografisk distrikt innenfor kommunen",
          },
          parish: {
            name: "Sogn",
            description: "Kirkesogn for adressen",
          },
          lkfCode: {
            name: "LKF-kode",
            description:
              "Statistisk områdekode (Fylke, Kommune, Sogn)",
          },
          municipalityCode: {
            name: "Kommunekode",
            description: "Offisiell numerisk kommunekode",
          },
          property: {
            name: "Eiendomsbetegnelse",
            description:
              "Offisiell eiendomsbetegnelse fra Kartverket",
          },
          coordinates: {
            name: "Koordinater",
            description:
              "Breddegrad og lengdegrad (WGS84) for adressen",
          },
          deso: {
            name: "DeSO",
            description: "Demografisk statistikkområde (SCB)",
          },
          regso: {
            name: "RegSO",
            description: "Regionalt statistikkområde (SCB)",
          },
          uuid: {
            name: "UUID",
            description: "Unik identifikator for adressen",
          },
          postalCode: {
            name: "Postnummer",
            description: "Verifisert og aktuelt postnummer",
          },
          city: {
            name: "Poststed",
            description:
              "Offisielt poststed knyttet til postnummeret",
          },
        },
      },
      useCases: {
        title: "Bruksområder",
        items: {
          checkout: {
            title: "E-handel checkout",
            description:
              "Integrer autocomplete og validering i kassen. Kunden fyller inn rett adresse direkte – færre returer, raskere levering.",
          },
          booking: {
            title: "Bookingportaler",
            description:
              "Sikre korrekte adresser ved servicebooking. Teknikeren finner rett med en gang uten unødvendige samtaler.",
          },
          systemIntegration: {
            title: "Systemintegrasjon",
            description:
              "Valider og berik adresser ved import til CRM, ERP eller markedsføringssystem. Sikre datakvalitet fra start.",
          },
          crmQuality: {
            title: "CRM-kvalitet",
            description:
              "Kjør kunderegistrene gjennom Valid for å identifisere og korrigere feilaktige adresser. Bedre data, bedre beslutninger.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Valid?",
        items: {
          returns: {
            title: "Færre returer",
            description:
              "Korrekte adressedata fra start betyr færre brev og pakker som kommer tilbake.",
          },
          experience: {
            title: "Bedre kundeopplevelse",
            description:
              "Raskere skjemaer med autocomplete og direkte validering. Kundene deres setter pris på det.",
          },
          costs: {
            title: "Lavere kostnader",
            description:
              "Hver feilaktig adresse koster penger. Valid betaler seg selv gjennom reduserte feilkostnader.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Integrer eller søk",
            description:
              "Koble Valid til systemet via REST API, eller bruk søketjenesten direkte i nettgrensesnittet.",
          },
          second: {
            title: "Valider og berik",
            description:
              "Adresser valideres i sanntid. Feilaktige adresser korrigeres og berikes med 10+ attributter automatisk.",
          },
          third: {
            title: "Korrekte data – alltid",
            description:
              "Hver adresse i systemet er verifisert, komplett og koblet til aktuelle geografiske data.",
          },
        },
      },
      demo: {
        title: "Test Valid",
        subtitle: "Prøv tjenesten direkte – velg land, skriv en adresse og se hvordan Valid validerer, foreslår og beriker i sanntid.",
        countryLabel: "Velg land:",
        countries: {
          se: "Sverige",
          no: "Norge",
          dk: "Danmark",
          fi: "Finland",
        },
        tabs: {
          autocomplete: "Autocomplete",
          validate: "Valider",
          enrich: "Berik",
        },
        autocomplete: {
          description: "Begynn å skrive en adresse og se forslag i sanntid. Velg et forslag for å fylle inn adressen.",
          placeholder: "Begynn å skrive en adresse…",
          selected: "Valgt adresse",
        },
        validate: {
          description: "Skriv inn en adresse og klikk på Valider for å kontrollere om den finnes og er korrekt.",
          streetLabel: "Gateadresse",
          streetPlaceholder: "f.eks. Karl Johans gate 1",
          postcodeLabel: "Postnummer",
          postcodePlaceholder: "f.eks. 0162",
          localityLabel: "Poststed",
          localityPlaceholder: "f.eks. Oslo",
          button: "Valider adresse",
          validMessage: "Adressen er korrekt!",
          invalidMessage: "Adressen kunne ikke valideres",
          suggestions: "Mente du kanskje:",
        },
        enrich: {
          description: "Skriv inn en adresse og klikk på Berik for å se all tilhørende geografisk og administrativ data.",
          button: "Berik adresse",
          errorMessage: "Adressen kunne ikke berikes. Kontroller at den er korrekt.",
        },
      },
      pricing: {
        features: {
          nordicValidation: "Validering av adresser i hele Norden",
          autocomplete: "Autocomplete for gatenavn, postnummer og poststeder",
          adminControl: "Kontroll av fylke, kommune, sokn og bydel",
        },
        details: {
          validationsIncluded: "Valideringer/mnd",
          autocompleteIncluded: "Autocomplete/mnd",
          extraValidation: "Overskytende validering",
          extraAutocomplete: "Overskytende autocomplete",
        },
        plans: {
          small: {
            name: "SMALL",
            price: "695 SEK",
            validations: "1 000",
            autocomplete: "7 500",
            extraValidation: "0,50 SEK",
            extraAutocomplete: "0,07 SEK",
          },
          medium: {
            name: "MEDIUM",
            price: "1 795 SEK",
            validations: "6 000",
            autocomplete: "45 000",
            extraValidation: "0,35 SEK",
            extraAutocomplete: "0,05 SEK",
          },
          large: {
            name: "LARGE",
            price: "3 995 SEK",
            validations: "20 000",
            autocomplete: "150 000",
            extraValidation: "0,25 SEK",
            extraAutocomplete: "0,03 SEK",
          },
          xl: {
            name: "XL",
            price: "5 995 SEK",
            validations: "40 000",
            autocomplete: "300 000",
            extraValidation: "0,15 SEK",
            extraAutocomplete: "0,01 SEK",
          },
        },
        addons: {
          geocodePostal: { name: "Geokoding postnummer", small: "1,00 SEK/stk", medium: "0,90 SEK/stk", large: "0,80 SEK/stk", xl: "0,70 SEK/stk" },
          geocodeAddress: { name: "Geokoding adresse", small: "Ifølge tilbud", medium: "Ifølge tilbud", large: "Ifølge tilbud", xl: "Ifølge tilbud" },
          uuid: { name: "UUID", small: "0,10 SEK/stk", medium: "0,08 SEK/stk", large: "0,06 SEK/stk", xl: "0,04 SEK/stk" },
          property: { name: "Eiendomsbetegnelse", small: "0,50 SEK/stk", medium: "0,40 SEK/stk", large: "0,30 SEK/stk", xl: "0,20 SEK/stk" },
          desoRegso: { name: "DeSO/RegSO", small: "0,60 SEK/stk", medium: "0,50 SEK/stk", large: "0,40 SEK/stk", xl: "0,30 SEK/stk" },
        },
      },
    },
    adresstwatt: {
      hero: {
        title: "Adressevask",
        tagline: "Vedlikehold av adresseregistre",
        subtitle:
          "Send inn adresseregisteret – få tilbake en vasket, korrigert og beriket versjon. Vi identifiserer feilaktige adresser, duplikater og utdaterte opplysninger i Sverige, Norge, Danmark og Finland.",
      },
      overview:
        "Adressevask er Geposits tjeneste for å kvalitetssikre eksisterende adresseregistre i hele Norden. Dere sender inn registeret i valgfritt format, og vi analyserer hver adresse mot vår oppdaterte database for Sverige, Norge, Danmark og Finland. Feilaktige adresser korrigeres, duplikater identifiseres og hver adresse berikes med de samme attributtene som Valid leverer – fra fylke og kommune til koordinater og DeSO/RegSO.",
      featureGroups: {
        analyze: "Analyser & identifiser",
        correctAndEnrich: "Korriger & berik",
      },
      features: {
        title: "Ren adressedata – i hele registeret",
        subtitle:
          "Adressevask tar hånd om eksisterende adressedata og sørger for at de holder høy kvalitet.",
        items: {
          analyze: {
            title: "Registeranalyse",
            description:
              "Vi analyserer eksisterende register og identifiserer feilaktige, ufullstendige og utdaterte adresser. Dere får en komplett kvalitetsrapport.",
          },
          correct: {
            title: "Korrigering mot offisielle data",
            description:
              "Feilaktige adresser korrigeres automatisk mot vår oppdaterte database med offisielle adresser fra nordiske grunnkilder.",
          },
          duplicates: {
            title: "Duplikatrensing",
            description:
              "Identifiser og håndter duplikater i registrene. Slå sammen, merk eller fjern for å få et rent kunderegister.",
          },
          enrich: {
            title: "Berikning med attributter",
            description:
              "Hver adresse berikes med de samme attributtene som Valid: fylke, kommune, koordinater, eiendomsbetegnelse, DeSO/RegSO med mer.",
          },
          report: {
            title: "Kvalitetsrapport",
            description:
              "Få en detaljert rapport med statistikk over antall korrigerte, fjernede og berikede adresser. Se nøyaktig hva som er gjort.",
          },
          flexible: {
            title: "Fleksible formater",
            description:
              "Send inn adressene i CSV, Excel eller via API. Få tilbake den vaskede versjonen i samme format – klar til import.",
          },
        },
      },
      useCases: {
        title: "Bruksområder",
        items: {
          registerCare: {
            title: "Registervedlikehold",
            description:
              "Regelmessig vask av kunderegister for å holde datakvaliteten høy. Kjør kvartalsvis eller før viktige kampanjer.",
          },
          campaigns: {
            title: "Kampanjeutsendelser",
            description:
              "Vask registeret før fysiske utsendelser. Unngå kostnaden for brev som ikke kommer frem på grunn av feilaktige adresser.",
          },
          gdpr: {
            title: "GDPR & datakvalitet",
            description:
              "Identifiser og rens utdaterte adresser som en del av GDPR-arbeidet. Hold bare de dataene dere faktisk trenger.",
          },
        },
      },
      benefits: {
        title: "Hvorfor Adressevask?",
        items: {
          quality: {
            title: "Høyere datakvalitet",
            description:
              "Et rent adresseregister er grunnlaget for all logistikk, markedsføring og kundekommunikasjon.",
          },
          savings: {
            title: "Direkte besparelser",
            description:
              "Hver korrigert adresse reduserer kostnaden for returer, feilutsendelser og manuell håndtering.",
          },
          compliance: {
            title: "Bedre kundedata",
            description:
              "Korrekte adresser forbedrer CRM-dataene og gir bedre grunnlag for forretningsbeslutninger.",
          },
        },
      },
      howItWorks: {
        steps: {
          first: {
            title: "Send inn registeret",
            description:
              "Last opp adresseregisteret i CSV, Excel eller via API. Vi støtter alle vanlige formater.",
          },
          second: {
            title: "Vi analyserer og vasker",
            description:
              "Hver adresse kontrolleres, korrigeres mot offisielle data, berikes med attributter og duplikater renses.",
          },
          third: {
            title: "Få tilbake rent register",
            description:
              "Dere får registeret tilbake – korrigert, beriket og med en detaljert kvalitetsrapport.",
          },
        },
      },
    },
    pricing: {
      tagline: "PAKKER OG PRISER",
      title: "Velg pakken som passer dere",
      subtitle: "Alle pakker inkluderer support og tilgang til vår dokumentasjon. Trenger dere større volumer? Kontakt oss for en skreddersydd løsning.",
      recommended: "Anbefalt",
      cta: "Kom i gang",
      ctaHighlighted: "Kom i gang",
      showAddons: "Vis tilvalg og variable priser",
      hideAddons: "Skjul tilvalg",
      addonColumn: "Tilvalg",
      perMonth: "/ mnd",
      shortBinding: "3 mnd bindingstid",
    },
  },
  solutionPages: {
    backToSolutions: "Alle løsninger",
    ctaButton: "Book demo",
    ctaSecondary: "Se våre tjenester",
    readMore: "Les mer",
    overview: {
      tagline: "LØSNINGER",
      title: "Løsninger for din bransje",
      subtitle: "Uansett om du jobber med transport, service eller e-handel – Geposit gir deg verktøyene til å optimalisere geografi og adressedata.",
      segments: {
        transport: {
          title: "Transport & Logistikk",
          description: "Optimaliser leveranseområder, reduser returer og sikre at hver levering når rett adresse. Definer egne soner og få full kontroll over transportgeografien.",
        },
        service: {
          title: "Service & Installasjon",
          description: "Planlegg serviceområder uten overlapp, fordel ressurser effektivt og gi kundene eksakte besøkstider basert på geografisk data.",
        },
        ecommerce: {
          title: "E-handel & Omni",
          description: "Valider kundeadresser i sanntid, definer leveransesoner og optimaliser siste-mil-logistikken for fornøyde kunder og færre returer.",
        },
      },
      cta: {
        title: "Usikker på hvilken løsning som passer?",
        subtitle: "Kontakt oss, så hjelper vi deg å finne rett løsning for din virksomhet.",
      },
    },
    transport: {
      hero: {
        tagline: "Transport & Logistikk",
        title: "Effektivere leveranser med geografisk kontroll",
        subtitle: "Definer leveranseområder med postnummerpresisjon, sikre korrekte adressedata og reduser returer – slik at hver levering når rett mottaker, til rett tid.",
      },
      challenges: {
        title: "Utfordringer innen transport",
        subtitle: "Transportselskaper sliter daglig med geografiske og adresserelaterte problemer som koster tid og penger.",
        items: {
          zones: {
            title: "Uklare leveransesoner",
            description: "Uten tydelig definerte leveranseområder havner pakker feil, soner overlapper og sjåføren mister tid på å rede ut grenseoppganger.",
          },
          routes: {
            title: "Uklare grenseoppganger",
            description: "Uten datadrevet soneplanlegging baseres ansvarsområder på magefølelse i stedet for data. Det fører til overlappende soner og hull i dekningen.",
          },
          returns: {
            title: "Høye returkostnader",
            description: "Feilaktige eller ufullstendige adresser fører til mislykkede leveranser. Hver retur koster penger og forverrer kundeopplevelsen.",
          },
        },
      },
      solutions: {
        title: "Slik hjelper Geposit transportselskaper",
        subtitle: "Med riktige verktøy kan dere ta kontroll over leveransegeografien og redusere kostbare feil.",
        items: {
          areas: {
            title: "Definer leveranseområder i Atlas",
            description: "Opprett og visualiser egne leveransesoner i Atlas med postnummerflater som byggesteiner. Ingen flere uklare grenser – alle ser det samme bildet.",
          },
          data: {
            title: "Valider adresser med Valid",
            description: "Med Valid valideres hver adresse før levering. Feilaktige adresser fanges direkte ved innmating, og dere unngår kostbare returer.",
          },
          optimize: {
            title: "Hold registeret rent med Adressevask",
            description: "Vask kunderegistrene regelmessig med Adressevask. Analyser leveranseområdene med underlagsdata og sikre at soneinndelingen matcher virkeligheten.",
          },
        },
      },
      products: {
        title: "Tjenester for transport",
        subtitle: "Tre verktøy som sammen gir full kontroll over leveransegeografi og adressekvalitet.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Opprett, visualiser og håndter leveransesoner med postnummerflater som byggesteiner. Definer områder per sjåfør, terminal eller region.",
          },
          valid: {
            name: "Valid",
            description: "Valider leveranseadresser i sanntid. Fang feilaktige adresser før pakken forlater terminalen og unngå kostbare returer.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Vask kunderegistrene regelmessig for å holde adressedata korrekte og oppdaterte. Reduser feilkostnader og øk leveransepresisjon.",
          },
        },
      },
      cta: {
        title: "Klar til å effektivisere leveransene?",
        subtitle: "Book en demo og se hvordan Geposit kan hjelpe transportselskapet med å redusere returer og optimalisere leveranseområder.",
      },
    },
    service: {
      hero: {
        tagline: "Service & Installasjon",
        title: "Smartere planlegging av serviceområder",
        subtitle: "Fordel ressurser geografisk, eliminer overlappende soner og gi kundene eksakte besøkstider – med Atlas, Valid og Adressevask som grunn.",
      },
      challenges: {
        title: "Utfordringer innen service",
        subtitle: "Serviceselskaper og installasjonsforetak møter daglig geografiske utfordringer som påvirker effektivitet og kundetilfredshet.",
        items: {
          overlap: {
            title: "Overlappende soner",
            description: "Uten tydelige grenser mellom serviceområder risikerer dere å sende flere teknikere til samme område, mens andre områder blir underbemannet.",
          },
          resources: {
            title: "Ujevn ressursfordeling",
            description: "Noen teknikere har for store områder, andre for små. Uten geografisk analyse baseres fordelingen på magefølelse.",
          },
          scheduling: {
            title: "Upresis tidsplanlegging",
            description: "Uten korrekte adresser og avstandsberegninger blir tidsvinduer upålitelige, noe som fører til misfornøyde kunder.",
          },
        },
      },
      solutions: {
        title: "Slik hjelper Geposit serviceselskaper",
        subtitle: "Med Geposits verktøy kan dere planlegge, visualisere og optimalisere serviceområdene basert på data.",
        items: {
          zones: {
            title: "Tydelige serviceområder i Atlas",
            description: "Definer eksakte serviceområder i Atlas med postnummerflater – ingen overlapp, ingen hull. Hver tekniker vet nøyaktig sitt ansvarsområde.",
          },
          address: {
            title: "Finn rett med Valid",
            description: "Med Valid sikres at hver kundeadresse er korrekt ved booking. Teknikeren finner rett direkte, og dere unngår kostbare bomturer.",
          },
          balance: {
            title: "Ren data med Adressevask",
            description: "Vask kunderegistrene med Adressevask og analyser serviceområdene med underlagsdata som antall kunder, avstander og reisetider.",
          },
        },
      },
      products: {
        title: "Tjenester for service",
        subtitle: "Verktøy som gir serviceteamet rett forutsetninger fra start.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Opprett og håndter serviceområder visuelt med postnummer som grunnlag. Fordel teknikere per sone og se hele servicegeografien på ett kart.",
          },
          valid: {
            name: "Valid",
            description: "Valider kundeadresser ved booking. Unngå bomturer ved å sikre at hver serviceadresse er korrekt.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Rens kunderegisterene fra feilaktige adresser. Sørg for at serviceplattformen bygger på korrekte og oppdaterte data.",
          },
        },
      },
      cta: {
        title: "Klar til å optimalisere serviceområdene?",
        subtitle: "Book en demo og se hvordan Geposit kan hjelpe serviceselskapet med å planlegge smartere og levere bedre.",
      },
    },
    ecommerce: {
      hero: {
        tagline: "E-handel & Omni",
        title: "Perfekt levering i hver kanal",
        subtitle: "Valider kundeadresser direkte i kassen, definer leveransesoner og sikre at hver ordre når rett mottaker – uansett kanal. Med Valid, Atlas og Adressevask.",
      },
      challenges: {
        title: "Utfordringer innen e-handel",
        subtitle: "E-handlere og omnikanalbedrifter sliter med adressekvalitet og leveransepresisjon i et stadig mer krevende marked.",
        items: {
          delivery: {
            title: "Utydelige leveransesoner",
            description: "Uten definerte leveranseområder er det vanskelig å tilby differensierte fraktalternativer og pris per sone.",
          },
          returns: {
            title: "Returer på grunn av adressefeil",
            description: "Kunder skriver inn feilaktige adresser, og uten validering sendes pakken likevel. Resultatet: returer, kostnader og misfornøyde kunder.",
          },
          expansion: {
            title: "Nordisk ekspansjon",
            description: "Å ekspandere til nye nordiske markeder krever korrekte adressedata for hvert land. Feilaktige data hindrer vekst og øker kostnadene.",
          },
        },
      },
      solutions: {
        title: "Slik hjelper Geposit e-handlere",
        subtitle: "Med riktige data og verktøy kan dere redusere returer, forbedre kundeopplevelsen og ekspandere tryggere.",
        items: {
          zones: {
            title: "Smarte leveransesoner i Atlas",
            description: "Definer leveranseområdene i Atlas med postnummerflater og koble dem til fraktalternativene. Tilby rett leveransevalg basert på kundens adresse – automatisk.",
          },
          validation: {
            title: "Adressevalidering med Valid i kassen",
            description: "Med Valid valideres kundens adresse direkte ved innmating. Autocomplete gir smarte forslag og feilaktige adresser korrigeres før ordren opprettes.",
          },
          quality: {
            title: "Ren kundedata med Adressevask",
            description: "Vask kunderegistrene regelmessig med Adressevask. Hold CRM-dataene rene og oppdaterte for bedre markedsføring og leveransepresisjon.",
          },
        },
      },
      products: {
        title: "Tjenester for e-handel",
        subtitle: "Alt dere trenger for korrekte adressedata og optimalisert leveranselogistikk.",
        items: {
          atlas: {
            name: "Atlas",
            description: "Definer leveransesoner per region eller fraktmetode med postnummerflater som grunnlag. Se leveranseområdene på kartet og optimaliser fraktstrukturen.",
          },
          valid: {
            name: "Valid",
            description: "Integrer adressevalidering direkte i kassen. Gi kunden riktige adresseforslag og unngå leveranseproblemer fra start.",
          },
          adresstwatt: {
            name: "Adressevask",
            description: "Kvalitetssikre kunderegistrene og hold dataene frie for feil. Perfekt for regelmessig rensing før kampanjer og utsendelser.",
          },
        },
      },
      cta: {
        title: "Klar til å forbedre leveransepresisjon?",
        subtitle: "Book en demo og se hvordan Geposit kan hjelpe e-handelen med å redusere returer og validere adresser i sanntid.",
      },
    },
  },
  socialProof: {
    logoTitle: "Over 900 selskaper stoler på Geposit",
    title: "Hva kundene våre sier",
    subtitle: "Vi hjelper ledende nordiske selskaper med å ta kontroll over sin geografi.",
    testimonials: {
      first: {
        quote:
          "Nå har vi mye færre områder der vi mangler dekning for tjenestene våre. Tidligere hadde vi 'blindsoner' i deler vi ellers kunne ha levert til. Oversikten i Atlas har gjort opptaksområdene våre både tydeligere og enklere.",
        author: "Björn Nilsson",
        company: "Systemansvarlig Webb, Elon",
      },
      second: {
        quote:
          "Smidig tjeneste for å spesifisere leveranseområder og dele dem inn i ulike soner. Enkelt å eksportere postnummerlister for hvert område.",
        author: "Julian Lee",
        company: "Grunnlegger, Airmee",
      },
    },
  },
  customerCases: {
    hero: {
      title: "Kundecase",
      subtitle: "Se hvordan nordiske selskaper bruker Geposit for å optimalisere geografien, redusere returer og effektivisere logistikken.",
    },
    logos: {
      title: "Selskaper som bruker Geposit",
      subtitle: "Over 900 selskaper, organisasjoner og myndigheter stoler på dataene våre.",
    },
    featured: {
      tagline: "Kundecase",
      title: "Raskere leveranser for markedslederen",
      company: "Best Transport",
      companyDesc: "Markedsledende aktør på raske leveranser i Norden.",
      description: "Best Transport er en markedsledende aktør på raske leveranser i Norden. For å møte kundenes krav om raske og treffsikre leveranser, stilles høye krav til velplanlagte og tydelige geografiske soner.",
      result: "Ved hjelp av karttjenesten Atlas som et enhetlig planleggingsverktøy kunne Best Transport skape både bedre oversikt og optimale distribusjonssoner. Resultatet ble høyere fyllingsgrad i kjøretøyene og dermed forbedret lønnsomhet, reduserte CO₂-utslipp – og fornøyde kunder!",
      stats: {
        efficiency: {
          value: "Fyllingsgrad",
          label: "Høyere fyllingsgrad i kjøretøyene",
        },
        emissions: {
          value: "CO₂",
          label: "Reduserte karbondioksidutslipp",
        },
        satisfaction: {
          value: "Tilfredshet",
          label: "Fornøyde sluttkunder",
        },
      },
      bullets: {
        challenge: "Kompleks sonestruktur med mange overlappende tjenester",
        solution: "Atlas som enhetlig planleggingsverktøy for soneinndeling",
        outcome: "Optimale distribusjonssoner med høyere fyllingsgrad",
      },
    },
    testimonials: {
      title: "Hva kundene våre sier",
      elon: {
        quote: "Nå har vi mye færre områder der vi mangler dekning for tjenestene våre. Tidligere hadde vi 'blindsoner' i deler vi ellers kunne ha levert til. Oversikten i Atlas har gjort opptaksområdene våre både tydeligere og enklere.",
        author: "Björn Nilsson",
        role: "Systemansvarlig Webb",
        company: "Elon",
      },
      airmee: {
        quote: "Smidig tjeneste for å spesifisere leveranseområder og dele dem inn i ulike soner. Enkelt å eksportere postnummerlister for hvert område.",
        author: "Julian Lee",
        role: "Grunnlegger",
        company: "Airmee",
      },
    },
    cta: {
      title: "Vil du bli neste suksesshistorie?",
      subtitle: "Book en demo og se hvordan Geposit kan effektivisere nettopp deres virksomhet.",
      button: "Book demo",
    },
  },
  cta: {
    title: "Klar til å ta kontroll?",
    subtitle:
      "Snakk med oss om hvordan Geposit kan hjelpe virksomheten deres med å optimalisere geografi og adressekvalitet.",
    form: {
      company: "Selskapsnavn",
      name: "Navn",
      email: "E-post",
      role: "Rolle",
      interest: "Hva vil du vite mer om?",
      interestOptions: {
        atlas: "Atlas – Geografiske områder",
        valid: "Valid – Adressevalidering",
        adresstwatt: "Adressevask – Adresserensing",
        general: "Generell informasjon",
      },
      message: "Melding (valgfritt)",
      submit: "Send forespørsel",
      success: "Takk for forespørselen! Vi tar kontakt med deg i løpet av kort tid.",
    },
  },
  footer: {
    description:
      "Geposit er Nordens ledende plattform for adresse- og geodata. Med korrekte og oppdaterte grunndata tilbyr vi nettbaserte tjenester, integrasjoner via API og data på fil.",
    quickLinks: "Hurtiglenker",
    products: "Tjenester",
    contact: "Kontakt",
    address: "Biblioteksgatan 29, 114 35 Stockholm",
    email: "info@geposit.se",
    phone: "+46 8 410 239 70",
    partOf: "En del av Progrits",
    progritsDesc:
      "Siden 2015 er Geposit en del av Progrits – en internasjonal programvarekonsern med fokus på e-handel, logistikk og kjøretøy.",
    sister: "Søsterselskap",
    postnummerservice: "Postnummerservice",
    postnummerserviceDesc:
      "Postnummerservice har siden 2005 hjulpet privatpersoner, selskaper og organisasjoner i Norden med korrekte og oppdaterte adresse-, postnummer- og geodata.",
    copyright: "© 2026 Geposit AB. Alle rettigheter reservert.",
    privacy: "Personvernpolicy",
    terms: "Vilkår",
  },
  about: {
    hero: {
      title: "Om Geposit",
      subtitle: "Fra svensk forhandler til nordisk SaaS-selskap innen geodata",
    },
    story: {
      title: "Vår historie",
      p1: "Geposit er en nordisk leverandør av digitale tjenester innen adresse- og geodata. Reisen vår begynte i 2005 under navnet Postnummerservice, da vi leverte oppdaterte adresse- og postnummerdata til kundene våre.",
      p2: "I 2010 lanserte vi automatisk adressekontroll og året etter kom vår første digitale karttjeneste for soneinndeling. I dag tilbyr vi digitale tjenester som forenkler, kvalitetssikrer og automatiserer håndteringen av adresser og geografiske data.",
      p3: "I dag brukes tjenestene våre av selskaper i hele Norden. Uansett om du trenger adresse- og datarensing, smart soneinndeling eller geodatatjenester via API, bygger løsningene våre alltid på korrekte og oppdaterte grunndata.",
    },
    data: {
      title: "Nordens mest pålitelige adressedata",
      description: "Visste du at adresser og postnummer endrer seg hver uke? Nye boligområder vokser frem, veier bygges om og byer endrer seg. Hvert år oppdateres ca. 250 000 adresser og postnummer i Sverige, noe som påvirker opp mot en halv million mennesker.",
      description2: "Hos Geposit samler vi kontinuerlig inn og bearbeider data fra pålitelige og offisielle grunnkilder som nasjonale postoperatører, kartverker og myndigheter. Takket være den høye kvaliteten i våre dataleveranser er vi i dag en verdsatt partner for over 900 selskaper, organisasjoner og myndigheter.",
      stats: {
        customers: "+5 000",
        customersLabel: "Fornøyde kunder siden 2005",
        countries: "4",
        countriesLabel: "Nordiske land",
        addresses: "250 000",
        addressesLabel: "Adresseendringer per år i Sverige",
      },
    },
    values: {
      title: "Vi drives av",
      innovation: {
        title: "Teknisk innovasjon",
        description: "Vi utvikler stadig nye løsninger med kundens nytte i sentrum. Vår teknologi bygger på pålitelige og oppdaterte grunndata.",
      },
      trust: {
        title: "Tillit og samarbeid",
        description: "Vi tror at tillit, inkludering og et oppmuntrende klima fører til engasjement og felles suksess.",
      },
      quality: {
        title: "Kvalitet i hver detalj",
        description: "Dataene våre oppdateres hver uke fra offisielle grunnkilder. Vi kompromisser aldri på kvaliteten.",
      },
    },
    progrits: {
      title: "En del av Progrits",
      description: "Siden 2015 er Geposit en del av Progrits – en internasjonal selskapsgruppe innen nisje-programvare og informasjonstjenester for business to business.",
      description2: "Innenfor Progrits samarbeider vi med andre B2B-selskaper for å skape sterkere kundetilbud og bedre arbeidsmåter.",
      tagline: "Software. Brains. Grit.",
      link: "Besøk progrits.se",
    },
    postnummerservice: {
      title: "Søsterselskap: Postnummerservice",
      description: "Postnummerservice har siden 2005 hjulpet privatpersoner, selskaper og organisasjoner i Norden ved å tilby korrekte og oppdaterte adresse-, postnummer- og geodata.",
      description2: "Postnummerservice samler og bearbeider data fra pålitelige grunnkilder som nasjonale postoperatører, kartverker og offisielle myndigheter. Data oppdateres hver uke for å garantere høy kvalitet og treffsikkerhet.",
      link: "Besøk postnummerservice.se",
    },
    careers: {
      title: "Bli en del av Geposit",
      description: "Vi vokser og ser alltid etter nye talenter. Vi drives av teknisk innovasjon, med kravet om at verdien for kundene alltid står i sentrum.",
      cta: "Kontakt oss",
    },
  },
  information: {
    title: "Informasjon",
    subtitle: "Nyheter, dokumenter og viktig informasjon fra Geposit.",
    news: {
      title: "Nyheter",
      subtitle: "Siste nytt fra Geposit – oppdateringer, forbedringer og nyheter.",
      empty: "Ingen nyheter publisert ennå.",
    },
    documents: {
      title: "Dokumenter og vilkår",
      subtitle: "Her finner du våre generelle vilkår, policyer og andre dokumenter.",
    },
    quickNav: {
      news: "Nyheter",
      documents: "Dokumenter & vilkår",
    },
    readMore: "Les mer",
    categories: {
      villkor: "Vilkår",
      policy: "Policy",
      ovrigt: "Annet",
    },
  },
  cookieBanner: {
    title: "Vi bruker informasjonskapsler",
    description: "Vi bruker informasjonskapsler for å forbedre opplevelsen din på nettsiden vår, analysere trafikk og tilpasse innhold.",
    readMore: "Les vår informasjonskapselpolicy",
    accept: "Aksepter",
    reject: "Avvis",
  },
  cookiePolicy: {
    title: "Informasjonskapselpolicy",
    lastUpdated: "Sist oppdatert: 2024-03-18",
    intro: "Vi samler inn informasjon ved hjelp av teknologi som informasjonskapsler (f.eks. i nettleseren eller enheten din). Informasjonskapsler brukes til å lagre og motta ID-er og annen informasjon på datamaskiner, telefoner og andre enheter. Informasjonskapsler kan for eksempel hjelpe oss med å gjenkjenne deg neste gang du besøker nettsiden vår, men også gjøre det mulig for oss å tilby en sikrere og mer driftssikker tjeneste.",
    purposeTitle: "Vi bruker informasjonskapsler for følgende formål",
    types: {
      functional: {
        title: "Funksjonelle informasjonskapsler",
        description: "Vi bruker funksjonelle informasjonskapsler for å håndtere visse funksjoner på sidene våre, slik at valgene og innstillingene dine huskes når du kommer tilbake til nettsiden.",
      },
      analytics: {
        title: "Analyseinformasjonskapsler",
        description: "Vi bruker analyseinformasjonskapsler for å måle hvordan tjenestene våre etterspørres, brukes og fungerer. Informasjonen vi samler inn brukes til å vedlikeholde og forbedre tjenesten vår.",
      },
      thirdParty: {
        title: "Tredjeparts informasjonskapsler",
        description: "Vi kan også tillate samarbeidspartnerne våre å bruke informasjonskapsler i tjenestene våre for de samme formålene som beskrevet ovenfor. Vi kan også la tredjeparter som tilbyr tjenester på våre vegne bruke informasjonskapsler for formålene beskrevet ovenfor.",
      },
    },
    managingTitle: "Håndtere informasjonskapsler",
    managingText: "De fleste nettlesere lar brukeren velge hvordan informasjonskapsler skal håndteres. Du kan stille inn nettleseren til å nekte informasjonskapsler, eller til å slette visse informasjonskapsler. Her finner du informasjon om hvordan du håndterer informasjonskapsler i nettleseren din:",
    blockingWarning: "Hvis du velger å blokkere informasjonskapsler kan deler av tjenestens funksjonalitet forringes eller forsvinne, da den forutsetter at informasjonskapsler tillates.",
    changesTitle: "Endringer i denne policyen",
    changesText: "Geposit kan fra tid til annen komme til å endre denne informasjonskapselpolicyen ved endrede rutiner for bruk av informasjonskapsler og behandling av data samt for å følge lovpålagte krav.",
    contactTitle: "Spørsmål",
    contactText: "Hvis du har noen spørsmål eller bekymringer om vår bruk av informasjonskapsler, kontakt oss.",
  },
  notFound: {
    title: "404",
    message: "Siden ble ikke funnet",
    backHome: "Tilbake til startsiden",
  },
  kontakt: {
    title: "Kontakt",
    hero: {
      title: "Hvordan kan vi hjelpe deg?",
      subtitle: "Book en gratis demo eller kontakt oss med dine spørsmål – vi hjelper deg å finne riktig løsning.",
    },
    types: {
      demo: {
        title: "Book demo",
        description: "Få en gratis gjennomgang av tjenestene våre, tilpasset din virksomhet.",
      },
      contact: {
        title: "Kontakt oss",
        description: "Har du spørsmål om produktene, prisene eller samarbeid? Ta kontakt!",
      },
    },
    contactInfo: {
      title: "Kontaktinformasjon",
    },
    form: {
      titleDemo: "Book en gratis demo",
      subtitleDemo: "Fyll inn skjemaet så kontakter vi deg for å avtale et tidspunkt som passer.",
      titleContact: "Send en melding",
      subtitleContact: "Beskriv saken din så kommer vi tilbake til deg så snart vi kan.",
      submitDemo: "Book demo",
      submitting: "Sender...",
      success: "Takk! Vi har mottatt meldingen din og tar kontakt i løpet av kort tid.",
      error: "Noe gikk galt. Prøv igjen eller kontakt oss via e-post.",
      placeholders: {
        company: "Selskap AS",
        name: "Ola Nordmann",
        email: "ola@selskap.no",
        role: "Logistikksjef",
        interest: "Velg et alternativ",
        messageDemo: "Fortell gjerne kort om virksomheten deres og hva dere ønsker å se i demoen...",
        messageContact: "Fortell gjerne mer om saken din...",
      },
    },
  },
  illustrations: {
    keyFactors: "Nøkkelfaktorer",
    joinCompanies: "Bli med 900+ selskaper som allerede bruker Geposit",
    zoneA: "Sone A",
    zoneB: "Sone B",
    zoneC: "Sone C",
    searchAddress: "Søk adresse…",
    processing: "Behandler…",
    completed: "ferdige",
    analysisResult: "Analyseresultat",
    addresses: "adresser",
    correctedAddresses: "Korrigerte adresser",
    addressFile: "adressevask.csv",
  },
  seo: {
    home: "Geposit hjelper bedrifter med å opprette, administrere og optimalisere sine geografiske områder med korrekte adressedata i Sverige, Norge, Danmark og Finland.",
    losningar: "Løsninger for transport, service og e-handel. Optimaliser leveringsområder og geografisk planlegging i hele Norden med Geposit.",
    produkter: "Oppdag Atlas, Valid og Adressevask – verktøy for geografisk områdeforvaltning og adressekvalitet i Sverige, Norge, Danmark og Finland.",
    kundcase: "Se hvordan 900+ bedrifter bruker Geposit for geografisk kontroll, bedre adressekvalitet og optimaliserte leveringssoner i Norden.",
    information: "Nyheter, oppdateringer og dokumenter fra Geposit om geografiske data, adressekvalitet og områdeforvaltning i Norden.",
    omGeposit: "Geposit hjelper nordiske bedrifter med geografisk kontroll og adressekvalitet. En del av Progrits-konsernet.",
    kontakt: "Kontakt Geposit – bestill en gratis demo eller still spørsmål om våre produkter og tjenester for geografiske data.",
    integritetspolicy: "Geposits personvernerklæring – slik håndterer vi dine personopplysninger og informasjonskapsler.",
  },
  order: {
    pageTitle: "Bestill",
    pageDescription: "Bestill Atlas eller Valid fra Geposit.",
    selectProduct: "Velg produkt",
    selectProductDesc: "Hvilket produkt ønsker du å bestille?",
    chooseThis: "Velg dette",
    configureAtlas: "Konfigurer Atlas",
    configureAtlasDesc: "Velg pakke og konfigurer abonnementet ditt.",
    configureValid: "Konfigurer Valid",
    configureValidDesc: "Velg pakke og eventuelle tillegg.",
    choosePlan: "Velg pakke",
    perMonth: "/mnd",
    binding12: "12 mnd bindingstid",
    binding3: "3 mnd bindingstid",
    perMonthShort: "mnd",
    adminUsers: "Admin-brukere",
    adminUsersDesc: "1 inkludert. Ekstra: 295 SEK/mnd",
    viewerUsers: "Se-brukere",
    viewerUsersDesc: "0 inkludert. Ekstra: 95 SEK/mnd",
    maps: "Kart",
    mapsDesc: "1 inkludert. Ekstra: 495 SEK/mnd",
    countries: { title: "Land", desc: "Minst 1 land kreves. Første inkludert, ekstra: 1 000 SEK/mnd", se: "Sverige", no: "Norge", dk: "Danmark", fi: "Finland" },
    addons: "Tillegg",
    addonsDesc: "Velg hvilke tillegg du ønsker utover grunnpakken.",
    userDetails: "Brukerdetaljer",
    userDetailsDesc: "Oppgi navn, e-post og rolle for hver bruker.",
    adminUser: "Admin-bruker",
    viewerUser: "Se-bruker",
    userName: "Navn",
    userNamePlaceholder: "Fornavn Etternavn",
    userEmail: "E-postadresse",
    userEmailPlaceholder: "navn@bedrift.no",
    userRole: "Rolle",
    userRolePlaceholder: "f.eks. Områdeansvarlig",
    noUsersNeeded: "Ingen brukerdetaljer nødvendig for dette produktet.",
    customerDetails: "Kunde- og fakturaopplysninger",
    customerDetailsDesc: "Fyll inn kontakt-, selskaps- og fakturaopplysninger.",
    contactInfo: "Kontaktopplysninger",
    firstName: "Fornavn",
    lastName: "Etternavn",
    phone: "Telefon",
    email: "E-postadresse",
    companyInfo: "Selskapsopplysninger",
    companyName: "Selskapsnavn",
    orgNumber: "Organisasjonsnummer",
    orgNumberHint: "10 siffer, fyll med nuller ved behov",
    address: "Adresse",
    postalCode: "Postnummer",
    city: "Sted",
    country: "Land",
    billingInfo: "Fakturaopplysninger",
    copyFromCompany: "Kopier fra selskapsopplysninger",
    billingAddress: "Faktureringsadresse",
    reference: "Deres referanse",
    referenceHint: "F.eks. navn på kontaktperson",
    poNumber: "Referanse/PO-nummer",
    poNumberHint: "F.eks. internt innkjøpsnummer. Ønsker dere å endre PO-nummer i fremtiden, må dere gi oss beskjed.",
    invoiceMethod: "Fakturametode",
    invoiceMethods: { email: "E-post", einvoice: "E-faktura", letter: "Brev" },
    invoiceEmail: "E-post for faktura",
    peppolId: "PEPPOL-ID",
    peppolIdHint: "Hvis ingen PEPPOL-ID, velg et annet alternativ",
    letterNotice: "Fakturaen sendes til oppgitt faktureringsadresse. Fakturagebyr tilkommer.",
    vatNumber: "VAT-nummer",
    termsPrefix: "Jeg godtar",
    termsLink: "kjøpsvilkårene",
    summary: "Sammendrag",
    basePlan: "(grunnpakke)",
    total: "Totalt",
    validAddonsNote: "Tilleggspriser er per stykk og kommer i tillegg til grunnpakken.",
    step: "Steg",
    back: "Tilbake",
    next: "Neste",
    submitOrder: "Fullfør bestilling",
    submitting: "Sender...",
    confirmationTitle: "Takk for din bestilling!",
    confirmationDesc: "Vi har mottatt bestillingen din og kommer tilbake med en bekreftelse via e-post.",
    backToHome: "Tilbake til startsiden",
    errorTitle: "Noe gikk galt",
    errorDesc: "Bestillingen din kunne ikke sendes. Vennligst prøv igjen eller kontakt oss.",
    share: "Del",
    shareOrder: "Del bestilling",
    shareCopied: "Lenke kopiert!",
    shareCopiedDesc: "Konfigurasjonlenken er kopiert til utklippstavlen.",
    shareFullCopied: "Bestillingslenke kopiert!",
    shareFullCopiedDesc: "Lenken inneholder alle opplysninger. Kunden trenger bare å godkjenne vilkårene.",
    sharedBanner: "Denne bestillingen er forberedt for deg. Gå gjennom valgene og gå videre for å fullføre.",
    sharedFullBanner: "Bestillingen er fylt ut for deg. Gå gjennom opplysningene, godkjenn vilkårene og send.",
  },
  villkor: {
    hero: {
      tagline: "Dokumenter og vilkår",
      title: "Tydelige vilkår for et trygt samarbeid",
      subtitle: "Her finner du et sammendrag av de viktigste punktene i våre vilkår samt mulighet til å laste ned de fullstendige dokumentene.",
    },
    summary: {
      title: "Sammendrag av våre vilkår",
      subtitle: "Nedenfor oppsummeres de viktigste punktene. De fullstendige vilkårene kan lastes ned lenger ned på siden.",
      disclaimer: "Det ovenstående er et forenklet sammendrag og erstatter ikke de fullstendige vilkårene. Ved eventuelle avvik gjelder alltid den signerte avtalen.",
      items: {
        contract: { title: "Avtaletid og oppsigelse", description: "Avtalen løper i henhold til valgt bindingstid og fornyes automatisk hvis den ikke sies opp skriftlig senest 3 måneder før periodens slutt." },
        payment: { title: "Betaling og priser", description: "Fakturering skjer på forskudd. Priser justeres årlig og kommuniseres på forhånd via nettstedet." },
        data: { title: "Data og personvern", description: "Geposit behandler kundedata konfidensielt og i samsvar med GDPR. Kundedata deles aldri med tredjepart uten samtykke." },
        responsibility: { title: "Ansvar og garantier", description: "Geposit er ansvarlig for at tjenesten fungerer i henhold til spesifikasjonen, med visse ansvarsbegrensninger. Se fullstendige vilkår for mer informasjon." },
        availability: { title: "Tilgjengelighet og SLA", description: "Tjenesten leveres med høy tilgjengelighet. Planlagt nedetid varsles på forhånd, og vedlikeholdsvinduer skjer utenfor kontortid." },
        usage: { title: "Bruk og begrensninger", description: "Tjenesten kan brukes innenfor rammen av avtalen. Misbruk, automatisert datautvinning eller videresalg/videredeling uten avtale er ikke tillatt." },
      },
    },
    download: {
      title: "Last ned fullstendige vilkår",
      subtitle: "Her kan du laste ned våre fullstendige avtaledokumenter i PDF-format.",
      open: "Åpne",
      empty: "Ingen dokumenter tilgjengelig akkurat nå.",
    },
    cta: {
      title: "Spørsmål om våre vilkår?",
      subtitle: "Ta kontakt så hjelper vi deg med å forstå hvordan vilkårene gjelder for nettopp din virksomhet.",
      button: "Kontakt oss",
    },
  },
  certifications: {
    title: "Sertifiseringer",
    subtitle: "Vi jobber systematisk med kvalitet, miljø og informasjonssikkerhet.",
    iso9001: { title: "ISO 9001", description: "Kvalitetsstyring" },
    iso14001: { title: "ISO 14001", description: "Miljøstyring" },
    iso27001: { title: "ISO 27001", description: "Informasjonssikkerhet" },
  },
  solutionExtras: {
    transport: {
      heroHighlights: [
        "Definer og visualiser leveringssoner med postnummer-presisjon i Atlas",
        "Valider alle adresser før utsending med Valid",
        "Hold kunderegisteret rent med Adressevask",
      ],
      challengeImpact: "Feil adresser og uklare leveringssoner koster transportselskaper millioner årlig i returer, bomturer og forsinkelser.",
      productBullets: {
        atlas: ["Bygg leveringssoner med postnummerpolygoner som byggesteiner", "Visualiser og analyser områder per terminal, sjåfør eller region"],
        valid: ["Valider leveringsadresser i sanntid før pakken forlater terminalen", "Fang opp feilaktige og ufullstendige adresser ved inntasting"],
        adresstwatt: ["Vask kunderegistre regelmessig for korrekte adressedata", "Identifiser og rett opp utdaterte adresser automatisk"],
      },
    },
    service: {
      heroHighlights: [
        "Definer presise serviceområder med postnummer-presisjon i Atlas",
        "Sikre korrekte kundeadresser ved booking med Valid",
        "Hold serviceplattformen ren med Adressevask",
      ],
      challengeImpact: "Overlappende serviceområder og feil adresser koster serviceselskaper i snitt 15–20 % av sin operative kapasitet i bomturer og dobbeltarbeid.",
      productBullets: {
        atlas: ["Bygg serviceområder med postnummerpolygoner – ingen overlapp", "Analyser arbeidsbelastning basert på kundeantall og geografi"],
        valid: ["Valider serviceadresser ved booking for å unngå bomturer", "Gi kunder korrekte adresseforslag i sanntid via autocomplete"],
        adresstwatt: ["Rens feil adresser i kunderegisteret regelmessig", "Sørg for at serviceplattformen bygger på korrekte data"],
      },
    },
    ecommerce: {
      heroHighlights: [
        "Valider kundeadresser direkte i kassen med Valid",
        "Definer leveringssoner med postnummer-presisjon i Atlas",
        "Ekspander trygt til nordiske markeder med korrekte data",
      ],
      challengeImpact: "Feil adresser i netthandel fører til at inntil 5 % av alle leveranser feiler – og returer koster 3–5 ganger mer enn opprinnelig frakt.",
      productBullets: {
        atlas: ["Bygg leveringssoner med postnummerpolygoner per region, fraktmåte eller prissone", "Visualiser leveringsområdene og eksporter postnummerlister"],
        valid: ["Integrer autocomplete direkte i kassen for feilfri adresseinntasting", "Valider adresser i sanntid for Sverige, Norge, Danmark og Finland"],
        adresstwatt: ["Kvalitetssikre kunderegistre før kampanjer og utsendelser", "Identifiser duplikater og utdaterte adresser i bulk"],
      },
    },
  },
  pricingDb: {
    nordicValidation: "Adressevalidering i hele Norden",
    autocomplete: "Autocomplete for gatenavn, postnummer og poststeder",
    adminControl: "Kontroll av fylke, kommune, sokn og distrikt",
    bindingTime12: "12 måneders bindingstid",
    oneAdminMapCountry: "1 admin, 1 kart, 1 land",
    importOwnData: "Importer egne data på kartet",
    createManageAreas: "Opprett, vis og administrer områder",
    integrateApi: "Integrer med systemene dine via API",
    export2000Postal: "Eksporter 2 000 postnummer/mnd",
    exportUnlimitedPostal: "Eksporter ubegrenset med postnummer",
    routingSmallIncluded: "Routing Small inkludert",
    validationsPerMonth: "Valideringer/mnd",
    autocompletePerMonth: "Autocomplete/mnd",
    extraValidation: "Overskytende validering",
    extraAutocomplete: "Overskytende autocomplete",
    geocodeAddress: "Geokoding adresse",
    geocodePostal: "Geokoding postnummer",
    propertyDesignation: "Eiendomsbetegnelse",
    uuid: "UUID",
    desoRegso: "DeSO/RegSO",
    extraCountry: "Ekstra land",
    extraMap: "Ekstra kart",
    extraAdmin: "Ekstra admin",
    extraViewer: "Ekstra titt-bruker",
    exportPostal: "Eksport postnummer",
    exportCoordinates: "Eksport koordinater",
    perQuote: "Etter tilbud",
    included: "Inkludert",
  },
};

